import React from "react";
import TextField from "@mui/material/TextField";
import Label from "./LabelF";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    textAlign: "right",
  },
  "& .css-nnbavb": {
    display: "none",
  },
});

const Number = (props) => {
  const { id, id_a, setFiltrosAAplicar, error, setError } = props;

  const handleInput = (e) => {
    const { value } = e.target;
    setFiltrosAAplicar((prevState) => {
      const nuevosFiltros = { ...prevState, [id_a]: value };
    
      if (props.clave_envio) {
        nuevosFiltros[props.clave_envio] = value;
      }
    
      return nuevosFiltros;
    });
    setError((e) => {
      return { ...e, [id_a]: false };
    });
  };

  return (
    <div>
      {props.nombre ? (
        <Label
          label={props.nombre}
          opcionales_null={props.opcionales_null}
          permite_null={props.permite_null}
        />
      ) : (
        <></>
      )}
      <StyledTextField
        id={id}
        label={props.label}
        type="number"
        placeholder={props.placeholder ? props.placeholder : "number"}
        style={{ width: "100%" }}
        onChange={handleInput}
        defaultValue={props.default}
        inputProps={{ style: { textAlign: "right" } }}
        error={error[id_a]}
        
      />
    </div>
  );
};

export default Number;
